import Dialog from "@chemaxon/terminus-client/ui/components/dialog/Dialog";
import { CornerExtraLarge } from "@chemaxon/design-system/corners";
import GroupEditor from "@chemaxon/terminus-client/ui/components/groups/GroupEditor";

export default function AddGroup(props: Props) {
  return (
    <Dialog
      title="Create new group"
      open={props.isShown}
      content={<GroupEditor onCancel={props.onCancel} />}
      onClose={props.onCancel}
      divider={false}
      borderRadius={CornerExtraLarge.borderRadius}
      maxWidth="md"
    />
  );
}

type Props = {
  isShown: boolean;
  onCancel: () => void;
};
